import { useContext } from 'react';
import { LocationContext } from '../contexts';
export const useLocationContext = () => useContext(LocationContext) || { locale: null, urlService: null, translations: null };
//# sourceMappingURL=useLocationContext.js.map